import React, { Fragment } from "react";
import PropTypes from "prop-types";
import DismissibleBanner from "components/Common/UI/Banner/DismissibleBanner";
import Textarea from "components/Common/Forms/Textarea";

const PropertyTextArea = ({
  isErrored,
  onChange,
  propertyLength,
  onDismissError,
  value
}) => {
  return (
    <Fragment>
      {isErrored && (
        <DismissibleBanner
          iconClassName="fa fa-exclamation-circle"
          text="Only the maximum 1,000 values will be saved."
          onClose={onDismissError}
        />
      )}
      <Textarea
        className="property-clause_text-area"
        resize
        isError={isErrored}
        value={(`${value}` || "").replace(/&#44;/g, "\\,")}
        placeholder="Enter values separated by commas or line breaks"
        onChange={onChange}
      />
      <p>{propertyLength + "/1000"}</p>
    </Fragment>
  );
};

PropertyTextArea.propTypes = {
  isErrored: PropTypes.bool,
  onChange: PropTypes.func,
  propertyLength: PropTypes.number,
  onDismissError: PropTypes.func,
  value: PropTypes.string
};

export default PropertyTextArea;
